import { useEffect, useState, ReactNode, FC, Fragment } from 'react';
import { LDSingleKindContext } from 'launchdarkly-js-client-sdk';
import { useCurrentAccountId, useCurrentProjectId, useUser } from '@adsk/alloy-provider';
import { getRegion, getEnv } from '@adsk/acs-sc-web-platform-api';
import FeatureFlags from '../helpers/featureFlags';
import { log, FeatureFlagsValues } from '../helpers';

type FeatureFlagsProviderProps = {
  loader?: ReactNode;
  defaultFeatureFlagsValues?: FeatureFlagsValues;
};

const FeatureFlagsProvider: FC<FeatureFlagsProviderProps> = (props) => {
  const { children, loader, defaultFeatureFlagsValues } = props;
  const [isFFLoaded, setIsFFLoaded] = useState(false);
  const projectId = useCurrentProjectId();
  const accountId = useCurrentAccountId();
  const user = useUser();
  const currentUser = user?.user;
  const { analyticsId } = currentUser || {};
  const initFeatureFlags = () => {
    const env = getEnv();
    const region = getRegion();
    const launchDarklyUserObject: LDSingleKindContext = {
      kind: 'user',
      region,
      accountId,
      projectId,
    };
    if (analyticsId) {
      launchDarklyUserObject.key = analyticsId;
    }
    FeatureFlags.initialize(env, launchDarklyUserObject, defaultFeatureFlagsValues)
      .then(() => {
        setIsFFLoaded(true);
      })
      .catch((e) => {
        log.error(new Error('Unable to get Launch Darkly response:'), { catchedError: e });
      });
  };

  useEffect(() => {
    if (projectId && accountId && analyticsId) {
      initFeatureFlags();
    }
  }, [projectId, accountId, analyticsId]);

  return <Fragment>{isFFLoaded ? children : loader}</Fragment>;
};

FeatureFlagsProvider.displayName = 'FeatureFlagsProvider';

export default FeatureFlagsProvider;
